export default "__VITE_ASSET__kLjsL4kE__"